/**
* This file was auto-generated by the FrontendConstantsGenerator.
* Do not make direct changes to the file.
*/

export const SOURCE_NAMES = {
  '1': 'Public',
  '2': 'Project',
  '4': 'Opt-in',
  '3': 'CSV',
  '5': 'API',
  '6': 'Researcher',
  '7': 'Staff',
};

export const PARTICIPANT_SOURCE_METADATA = {
  ApiImport: { label: 'API', id: 5},
  FileUpload: { label: 'CSV', id: 3},
  ParticipantPopulationOptInForm: { label: 'Opt-in', id: 4},
  Project: { label: 'Project', id: 2},
  Account: { label: 'Researcher', id: 6},
  User: { label: 'Staff', id: 7},
};
